export const formatTaskDate = (dateString, intl) => {
  if (!dateString) return '--'

  try {
    return intl.formatDate(new Date(dateString), {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch (error) {
    console.warn('Error formateando fecha:', dateString)
    return '--'
  }
}

export const findComboItem = (comboData, searchKey) => {
  if (!comboData?.data || !searchKey) return undefined

  return comboData.data.find((item) => item.key.split('|').includes(searchKey.toString()))
}

export const findEstadoByKey = (estadosData, estadoKey) => {
  if (!estadosData?.data || !estadoKey) return undefined

  return estadosData.data.find((estado) => estado.key === estadoKey.toString())
}
